
import { supabase } from "@/lib/supabase";
import { CheckoutSessionOptions } from "../types";

export const CheckoutService = {
  /**
   * Create a checkout session for subscription
   * This is used for bizadmins subscribing to the platform
   */
  createCheckoutSession: async (options: CheckoutSessionOptions) => {
    try {
      console.log("Creating checkout session", options);
      
      const { data, error } = await supabase.functions.invoke("create-checkout", {
        body: options
      });
      
      if (error) {
        console.error("Error invoking create-checkout function:", error);
        throw error;
      }
      
      console.log("Checkout session created successfully", data);
      return data;
    } catch (error) {
      console.error("Error creating checkout session:", error);
      return { error: error instanceof Error ? error.message : "Unknown error" };
    }
  }
};
